import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { FiArrowLeft, FiLock } from "react-icons/fi";
import { RoutesPaths } from "../Router/constant";

/*
 * Renders children only for admins. The role is written to localStorage by
 * App after token verification, so on a fresh load it can arrive a moment late;
 * poll briefly (same approach as Dashboard) before deciding.
 */
export default function AdminOnly({ children }) {
  const [role, setRole] = useState(() => localStorage.getItem("userRole"));
  const [checked, setChecked] = useState(Boolean(localStorage.getItem("userRole")));

  useEffect(() => {
    if (role) return undefined;
    let tries = 0;
    let timer;

    const poll = () => {
      const stored = localStorage.getItem("userRole");
      if (stored) {
        setRole(stored);
        setChecked(true);
      } else if (tries++ < 15) {
        timer = setTimeout(poll, 200);
      } else {
        setChecked(true);
      }
    };

    poll();
    return () => clearTimeout(timer);
  }, [role]);

  if (!checked) {
    return (
      <div className="container-fluid qd-page">
        <div className="qd-card qd-panel">
          <div className="qd-skel" style={{ height: 40, marginBottom: 12 }} />
          <div className="qd-skel" style={{ height: 240 }} />
        </div>
      </div>
    );
  }

  if (role !== "admin") {
    return (
      <div className="container-fluid qd-page">
        <div className="qd-card qd-panel">
          <div className="qu-empty">
            <span className="qu-empty-art">
              <FiLock />
            </span>
            <h6>Admins only</h6>
            <p>You don&apos;t have access to this page.</p>
            <NavLink to={RoutesPaths.DASHBOARD} className="qd-btn qd-btn-primary">
              <FiArrowLeft /> Back to dashboard
            </NavLink>
          </div>
        </div>
      </div>
    );
  }

  return children;
}
